import { Box, Icon, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SelectListItem from 'modules/reports/components/Editor/FieldSelectorModal/SelectListItem'
import Tooltip from 'modules/reports/components/Editor/FieldSelectorModal/Tooltip'
import { default as FieldModel } from 'modules/reports/store/models/Field'

const TYPES: Record<string, React.ComponentProps<typeof Icon.Medium>['icon']> = {
  text: 'text',
  dropdown: 'text',
  number: 'numbers',
  rating: 'numbers',
  identifier: 'numbers',
  cents: 'numbers',
  money: 'numbers',
  bytes: 'numbers',
  date: 'calendar',
  enum: 'layers-front',
  boolean: 'layers-front',
  cohort: 'clock',
  link: 'link',
  single_choice: 'text',
  unit: 'text',
  amount: 'numbers',
  hours: 'numbers',
}

interface Props {
  field: FieldModel
  selectedFields: FieldModel[]
  selection: string[]
  disabled: boolean
  description?: string
  onClickItem: (field: FieldModel) => void
}

const Field = ({ disabled, description, selection, field, selectedFields, onClickItem }: Props) => {
  const checkedSet = new Set(selectedFields.map((f) => f.attributes.path))
  const disabledSet = new Set(selection)

  const iconName = TYPES[field.attributes.type] ?? 'text'
  const [tooltip, tooltipToggle] = useToggle(false)
  const [infoTooltip, infotooltipToggle] = useToggle(false)

  const renderIcon = (selected: boolean) =>
    iconName && <Icon.Medium icon={iconName} color={selected ? 'viridian1000' : 'grey600'} />

  return (
    <Box
      paddingX="s32"
      height="s64"
      justifyContent="center"
      onMouseEnter={tooltipToggle(true)}
      onMouseLeave={tooltipToggle(false)}
    >
      {disabled && tooltip && !infoTooltip && (
        <Tooltip label={i18n.t('custom_reports.editor.incompatible_field_selection')} />
      )}

      <SelectListItem
        onClick={() => onClickItem(field)}
        selected={checkedSet.has(field.attributes.path ?? '')}
        disabled={disabledSet.has(field.attributes.path ?? '')}
        illustration={renderIcon}
        label={field.attributes.label ?? ''}
        right={
          <>
            {description && (
              <Box
                onMouseEnter={infotooltipToggle(true)}
                onMouseLeave={infotooltipToggle(false)}
                paddingTop="s2"
                paddingLeft="s4"
              >
                <Icon.Medium color={disabled ? 'grey600' : 'grey800'} icon="info-circle-line" />
                {infoTooltip && <Tooltip label={description} />}
              </Box>
            )}
          </>
        }
      />
    </Box>
  )
}

export default Field
